import * as React from "react";

const NewsPage: React.FC<{ children?: React.ReactNode }> = (props) => (
  <div>{props.children}</div>
);

export default NewsPage;
